'use client';

import { datadogRum } from '@datadog/browser-rum';
import { deleteCookie, getCookie } from 'cookies-next';
import { useEffect } from 'react';

interface DatadogInitPropsEnabled {
  isEnabled: true;
  env?: string;
  sampleRate?: string;
  replaySampleRate?: string;
  revision?: string;
  applicationId: string;
  clientToken: string;
  service: string;
}

interface DatadogInitPropsDisabled {
  isEnabled: false;
}

export type DatadogInitProps =
  | DatadogInitPropsEnabled
  | DatadogInitPropsDisabled;

export default function DatadogInit(props: DatadogInitProps) {
  useEffect(() => {
    if (props.isEnabled) {
      const {
        env,
        sampleRate,
        replaySampleRate,
        revision,
        applicationId,
        clientToken,
        service,
      } = props;

      if ((getCookie('_dd_s')?.indexOf('rum=2') ?? -1) < 0) {
        deleteCookie('_dd_s');
      }

      datadogRum.init({
        applicationId,
        clientToken,
        site: 'datadoghq.com',
        service,
        env: env || 'local',
        sessionSampleRate: parseInt(sampleRate || '100', 10),
        sessionReplaySampleRate: parseInt(replaySampleRate || '0', 10),
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        version: revision || '',
      });
    }
  }, [props]);

  return null;
}
